import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { DataProvider } from 'assets/providers/data/DataProvider';
import { HttpStatus, dealerManagementHomeRoute } from 'config/Api.Config';
import React from 'react';
import { isDesktop, isMobile } from 'react-device-detect';
import useDealerGroup, { DealerGroupAction } from './DealerGroup.Hooks';
import DealerGroupDelete from './sections/DealerGroup.Delete';
import DealerGroupEdit from './sections/DealerGroup.Edit';
import DealerGroupFilters from './sections/DealerGroup.Filters';
import DealerGroupList from './sections/DealerGroup.List';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export const dealerGroupIndexRoute = dealerManagementHomeRoute + '/dealer-group/:action?/:id?';
export default function DealerGroupIndex() {
  const { lang } = getLocales();
  const dealerGroupHook = useDealerGroup();
  const { permissions } = useAuthStore();

  if (!dealerGroupHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={dealerGroupHook}
        render={({ listApi, views, pageRouter }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.groups} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <DealerGroupFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.CREATE_DEALERGROUP}
                    data={{ action: DealerGroupAction.EDIT }}
                  />
                </Box>
              </>
            }
            subHeader={isDesktop && <DealerGroupFilters />}
            render={
              <>
                {views.edit && <DealerGroupEdit />}
                {views.delete && <DealerGroupDelete />}
                <DealerGroupList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
